export type IntentLevel = 'A' | 'B' | 'C';
export type SyncStatus = 'synced' | 'pending' | 'failed';
export type OcrProvider = 'openai' | 'tencent';
export type OfflineDraftStatus = 'queued' | 'syncing' | 'failed' | 'review';

export interface LeadForm {
  name: string;
  jobTitle: string;
  company: string;
  email: string;
  phone: string;
  address: string;
  website: string;
  intentLevel: IntentLevel;
  needs: string;
  notes: string;
  exhibitionName: string;
  communicationDate: string;
}

export interface Customer extends LeadForm {
  id: string;
  syncStatus: SyncStatus;
  syncError?: string | null;
  larkRecordId?: string | null;
  createdAt: string;
}

export interface DuplicateCandidate extends Customer {
  duplicateFields: Array<'email' | 'phone'>;
}

export interface OfflineDraft {
  id: string;
  createdAt: string;
  updatedAt: string;
  form: LeadForm;
  image?: Blob;
  imageName?: string;
  imageType?: string;
  ocrComplete: boolean;
  status: OfflineDraftStatus;
  error: string | null;
  duplicateCandidates: DuplicateCandidate[];
}

export interface PublicSettings {
  lark: {
    configured: boolean;
    appIdHint: string;
    appTokenHint: string;
    tableIdHint: string;
  };
  ocr: {
    provider: OcrProvider;
    configured: boolean;
    apiBase: string;
    model: string;
    tencentSecretIdHint: string;
    tencentRegion: string;
  };
  webhookConfigured: boolean;
}

export const emptyLead = (): LeadForm => ({
  name: '',
  jobTitle: '',
  company: '',
  email: '',
  phone: '',
  address: '',
  website: '',
  intentLevel: 'B',
  needs: '',
  notes: '',
  exhibitionName: '',
  communicationDate: new Date().toISOString().slice(0, 10),
});
